// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"index-module_searchBox_22J4-"};